import API from './API';
import User from '../models/User';
import moment from 'moment';
import Product from '../models/Product';
import RenewLog from '../models/RenewLog';
import {getRandomDeviceId, getRandomUsername} from "../util/util";
import Question from "../models/Question";
import Payment from "../models/Payment";
import {Toast} from "antd-mobile";

let MD5 = require('md5.js')
let debug = require('debug')('APP:DAL')


class DAL {

    isDataLoaded = false

    isUserRegistered = false

    state = {
        user: new User(),
        configFileUrl: '',
        products: new Array<Product>(),
        renewLogs: new Array<RenewLog>(),
        questions: new Array<Question>(),
        ticketDetail: new Array<Question>(),
        paymentConfigs: new Array<Payment>()
    };

    api = new API();


    saveStorage() {
        let s = this.state.user.serialize()
        debug('saveStorage user: %o', s)
        localStorage.setItem('user', s)
    }

    // test user
    /*        let username = 'sky_0b6fdf60749e3bcf82f7d97baaf6978c_win'
            let token = '2bea59e52d09d71b3ff60fc46ee929f1'*/
    /**
     * 从存储中加载用户信息
     * @returns {boolean}
     */
    loadStorage():boolean {
        debug('loadStorage')

        let serializedUser = localStorage.getItem('user')
        if (serializedUser !== null) {
            let userJson = JSON.parse(serializedUser!)
            this.state.user.setProperties(userJson)
            this.isDataLoaded = true
            this.isUserRegistered = true
            this.setApiAuth()
            return true
        } else {
            return false
        }
    }

    async autoRegister(username?: string) {
        let deviceId = getRandomDeviceId()
        if (username === undefined) {
            username = getRandomUsername()
        }
        let deviceName = navigator.appName
        let secret = new MD5().update(username + deviceId).digest('hex')

        debug('autoRegister username:%o, deviceId:%o, username+deviceId:%o, secret:%o', username, deviceId, username + deviceId, secret)

        let rsp = await this.api.autoRegister(username, secret, deviceId, deviceName)
        return new Promise<any>((resolve, reject) => {
            if (rsp.data.status === 0) {
                this.state.user.username = rsp.data.data.username
                this.state.user.token = rsp.data.data.token

                this.state.user.vipEndTime = moment(rsp.data.data.vipEndTimeStr);
                this.state.user.vipLeftSeconds = rsp.data.data.vipTimeLeft;

                this.isUserRegistered = true
                this.setApiAuth()
                this.saveStorage()
                resolve();
            } else if (rsp.data.status === -1) {
                reject(rsp.data.msg)
            }

        })
    }

    setApiAuth() {
        this.api.setAuth(this.state.user.username, this.state.user.token)
    }

    async syncServerUserData() {
        let rsp = await this.api.locations()

        debug('syncServerUserData rsp:', rsp)
        if (rsp.data.status !== 0) {
            Toast.fail(rsp.data.msg)
            return
        }
        this.state.products =  new Array<Product>();
        (rsp.data.data.products || []).forEach((v: any) => {
            let p: Product = {
                id: v.id,
                name: v.name,
                price: v.price,
                priceNew: v.priceNew,
                priceOld: v.priceOld,
                desc: v.desc
            };
            this.state.products.push(p);
        });
        this.state.paymentConfigs = rsp.data.data.paymentConfigs
        this.state.user.vipEndTime = moment(rsp.data.data.user.vipEndTimeStr);
        this.state.user.vipLeftSeconds = rsp.data.data.user.vipTimeLeft;
        this.state.user.notice = rsp.data.data.notice;
        if (rsp.data.data.recoverCode) {
            this.state.user.recoverCode = rsp.data.data.recoverCode

        }

        this.saveStorage();

        return rsp;
    }

    async fetchConfigFileUrl() {
        let rsp = await this.api.acquire();

        debug('fetchConfigFileUrl rsp:', rsp);

        //this.state.notice = rsp.data.data.configUrl;

        return rsp;
    }

    async recoverMember(paymentId: string) {
        return new Promise<any>((resolve, reject) => {
            this.api.vipRecover(paymentId).then(rsp => {
                debug('recoverMember', rsp)
                if (rsp.data.status === 0) {
                    this.state.user.username = rsp.data.data.username
                    this.state.user.token = rsp.data.data.token
                    this.state.user.vipEndTime = moment(rsp.data.data.vipEndTimeStr);
                    this.state.user.vipLeftSeconds = rsp.data.data.vipTimeLeft;

                    this.api.setAuth(this.state.user.username, this.state.user.token)
                    this.saveStorage()
                    resolve();
                } else if (rsp.data.status === -1) {
                    reject(rsp.data.msg)
                }
            })
        })
    }

    async fetchRenewLog() {
        let rsp = await this.api.vipRenewLog();
        debug('fetchRenewLog', rsp)
        this.state.renewLogs = new Array();
        rsp.data.data.vipRenewLogs.forEach((v: any) => {
            let renewLog: RenewLog = {
                desc: v.desc,
                cost: v.cost,
                duration: v.duration,
                createTime: v.createTime,
                orderId: v.orderId,
                paymentId: v.paymentId
            };
            this.state.renewLogs.push(renewLog)
        })
        debug(this.state.renewLogs)
    }

    async getListTicket() {
        let rsp = await this.api.listTicket();
        debug('getListTicket', rsp);
        this.state.questions = new Array();
        let status = rsp.data.status;
        if (status === 0) {
            rsp.data.data.tickets.map((item: any) => {
                let question: Question = {
                    id: item.id,
                    fromUser: item.fromUser,
                    content: item.content,
                    viewed: item.viewed,
                    createTimeMills: item.createTimeMills,
                    ticket: item.ticket
                };
                this.state.questions.push(question);
            });
            debug(this.state.questions)
        }
    }

    async getTicketDetail(ticketId: string) {
        let rsp = await this.api.getTicketdetail(ticketId);
        let status = rsp.data.status;
        this.state.ticketDetail = new Array();
        if (status === 0) {
            rsp.data.data.tickets.map((item: any) => {
                let question: Question = {
                    id: item.id,
                    fromUser: item.fromUser,
                    content: item.content,
                    viewed: item.viewed,
                    createTimeMills: item.createTimeMills,
                    ticket: item.ticket
                };
                this.state.ticketDetail.push(question);
            });
            debug(this.state.ticketDetail)
        }
    }

    async addQuestion(content: string) {
        let rsp = await this.api.addQuestion(content);
        debug(rsp);
        return rsp;
    }

    async replyQuestion(ticketId: string, content: string) {
        let rsp = await this.api.replyQuestion(ticketId, content);
        return rsp
    }

    async getWXPayUrl(productId: string,extra:string) {
        let rsp = await this.api.wxH5XCharge(productId,extra);
        return rsp
    }
    async getAliPayUrl(productId: string,extra:string) {
        let rsp = await this.api.aliPayH5XCharge(productId,extra)
        return rsp
    }
    async getPPPayUrl(productId: string,extra: string) {
        let rsp = await this.api.ppH5XCharge(productId,extra)
        return rsp
    }
    async getUPPayUrl(productId: string,extra: string) {
        let rsp = await this.api.upH5XCharge(productId,extra)
        return rsp
    }
    async getPayResult(orderId: string) {
        let rsp = await  this.api.paymentCheck(orderId);
        return rsp;
    }


    getToken(): String {
        return this.api.token;
    }

    getUsernameFromUrl() {
        let splits = window.location.search.match(RegExp('username=(.*)'))
        if (splits !== null) {
            return splits[1]
        }
        return null
    }



}

let dal = new DAL()

export default dal;
